import { render, staticRenderFns } from "./ModalAddOrigin.vue?vue&type=template&id=af4ccfce&scoped=true&"
import script from "./ModalAddOrigin.vue?vue&type=script&lang=js&"
export * from "./ModalAddOrigin.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddOrigin.vue?vue&type=style&index=0&id=af4ccfce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ccfce",
  null
  
)

export default component.exports